import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

interface SectionEmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function SectionEmptyState({ icon: Icon, title, description, action, className }: SectionEmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-14 text-center', className)}>
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-muted">
          <Icon className="h-6 w-6 text-fg-subtle" aria-hidden />
        </div>
      )}
      <p className="text-sm font-semibold text-fg">{title}</p>
      {description && (
        <p className="mt-1 max-w-xs text-xs text-fg-muted">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
